import _ from "lodash";
import {
  FETCH_INTENTS,
  CREATE_NEW_INTENT,
  BUILD_BOT,
  BOT_STATUS,
  DISABLE_INTENT,
  CLEAR_DISABLE_INTENT_RESPONSE,
  RE_ENABLE_INTENT,
  CLEAR_RE_ENABLE_INTENT_RESPONSE,
  TRIGGER_BUILD_BOT,
  TRIGGER_CHECK_BOT_STATUS,
  UPDATE_FALLBACK_INTENT,
  CLEAR_UPDATE_FALLBACK_INTENT_RESPONSE
} from "./types";
import { API, Auth } from "aws-amplify";
import AWS from "aws-sdk";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

const apiRequestFixedParams = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const fetchIntents = () => async (dispatch, getState) => {
  const state = getState();

  let data = {
    queryStringParameters: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GetIntents2",
      Skill: state.skill.ID
    }
  };
  const response = await API.get(config.AWS_API_NAME, "intents", data);

  dispatch({
    type: FETCH_INTENTS,
    payload: response.data
  });
};

export const createNewIntents = intentId => async (dispatch, getState) => {
  const state = getState();

  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "CreateIntentFromTemplate",
      skillId: state.skill.ID,
      templateIntentId: intentId,
      ...apiRequestFixedParams
    }
  };
  let successful = "";
  try {
    const response = await API.post(config.AWS_API_NAME, "intents/new", data);
    successful = response.code === 200;
  } catch (err) {
    successful = false;
  }
  dispatch({
    type: CREATE_NEW_INTENT,
    payload: successful
  });
};

export const buildBot = skillId => async (dispatch, getState) => {
  const state = getState();

  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "BuildSkill",
      Skill: !skillId ? state.skill.ID : skillId,
      ...apiRequestFixedParams
    }
  };
  let payload = {
    successful: false,
    message: ""
  };
  try {
    const response = await API.post(config.AWS_API_NAME, "/skill/build-bot", data);
    payload["message"] = response.message;
    payload["successful"] = response.code === 200;
    payload["response"] = response;
  } catch (err) {}
  dispatch({
    type: BUILD_BOT,
    payload: payload
  });
};

export const checkBotStatus = () => async (dispatch, getState) => {
  const state = getState();

  // sets default values
  const skillId = state.skill.ID;
  const botName = state.skill.lex_bot_name;

  let payload = {
    message: "",
    type: "info",
    refresh: false,
    refreshInterval: 0
  };

  const botIsStillBuilding = () => {
    payload["message"] = "Bot is building, please wait...";
    if (!_.isEmpty(state.intents.botBuilt)) {
      if (
        state.intents.botBuilt["response"].hasOwnProperty("interaction_model_updated") &&
        state.intents.botBuilt["response"].interaction_model_updated
      ) {
        payload["message"] = "Alexa interaction model updated. Bot is building, please wait...";
      } else if (
        state.intents.botBuilt["response"].hasOwnProperty("interaction_model_updated") &&
        !state.intents.botBuilt["response"].interaction_model_updated &&
        state.intents.botBuilt["response"].hasOwnProperty("interaction_model_updated_error")
      ) {
        payload["message"] =
          "Failed to update interaction model: " +
          state.intents.botBuilt["response"].interaction_model_updated_error +
          " Bot is building, please wait...";
      }
    }
    payload["refresh"] = true;
    payload["refreshInterval"] = 5000;
  };

  const botBuildingFailed = () => async () => {
    let data = {
      body: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        ApiCall: "GetBuildStatus",
        Skill: skillId, //state.skill.ID,
        ...apiRequestFixedParams
      }
    };
    try {
      const response = await API.post(config.AWS_API_NAME, "/skill/build-bot ", data);
      if (response.buildStatus === "error") {
        payload["type"] = "error";
        payload["message"] = response.message;
      } else if (response.buildStatus !== "success" && response.buildStatus !== "info") {
        payload["type"] = "info";
        payload["message"] = response.message;
        payload["refreshInterval"] = 1000;
        payload["refresh"] = true;
      }
      waitForIt = false;
    } catch (err) {
      payload["type"] = "error";
      payload["message"] = "Internal error. If this error persist over multiple builds please contact our support";
      waitForIt = false;
    }
  };

  const handleLexError = err => {
    console.log("err", err.stack);
  };

  let credentials = await Auth.currentCredentials();
  AWS.config = new AWS.Config();
  AWS.config.accessKeyId = credentials.accessKeyId;
  AWS.config.secretAccessKey = credentials.secretAccessKey;
  AWS.config.sessionToken = credentials.sessionToken;
  AWS.config.region = config.AWS_REGION;
  let params = {
    name: botName,
    versionOrAlias: "$LATEST"
  };
  const lex = new AWS.LexModelBuildingService({ apiVersion: "2017-04-19" });
  let waitForIt = true;

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  const waitForBotStatusCallback = async () => {
    await sleep(100);
    if (waitForIt) {
      await waitForBotStatusCallback();
    }
  };

  lex.getBot(params, function(err, data) {
    if (err) {
      handleLexError(err);
      waitForIt = false;
    } // an error occurred
    else {
      if (data.status === "BUILDING") {
        botIsStillBuilding(data);
        waitForIt = false;
      } else if (data.status === "NOT_BUILT") {
        payload["type"] = "error";
        payload["message"] =
          "Bot NOT READY, please try to build a skill. If the issue persists, contact your administrator.";
        waitForIt = false;
      } else if (data.status === "FAILED") {
        dispatch(botBuildingFailed(data));
      } else {
        if (!_.isEmpty(state.intents.botBuilt) && state.intents.botBuilt["message"] === "No updated intents.") {
          console.log("---------");
          payload["message"] = "Nothing to update. Bot already up-to-date.";
          payload["type"] = "warning";
        } else {
          payload["message"] = "But successfully updated";
          payload["type"] = "success";
        }
        waitForIt = false;
        dispatch(triggerBotBuilding(false));
      }
    }
  });
  await waitForBotStatusCallback();
  dispatch({
    type: BOT_STATUS,
    payload: payload
  });
};

export const disableIntent = intentId => async (dispatch, getState) => {
  const state = getState();

  const requestData = {
    body: {
      ApiCall: "DeleteIntent",
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      IntentId: intentId,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: DISABLE_INTENT,
    payload: { response: {} }
  };

  try {
    action.payload.response = await API.post(config.AWS_API_NAME, "intents", requestData);
  } catch (err) {
    action.payload.response = {
      status: "error",
      code: 500,
      message: "Could not disable intent, please try again later"
    };
  }

  dispatch(action);
};

export const clearDisableIntentResponse = () => {
  return {
    type: CLEAR_DISABLE_INTENT_RESPONSE
  };
};

export const reEnableIntent = intentId => async (dispatch, getState) => {
  const state = getState();

  const requestData = {
    body: {
      ApiCall: "RestoreIntent",
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      IntentId: intentId,
      SkillId: state.skill.ID,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: RE_ENABLE_INTENT,
    payload: { response: {} }
  };

  try {
    action.payload.response = await API.post(config.AWS_API_NAME, "intents", requestData);
  } catch (err) {
    action.payload.response = {
      status: "error",
      code: 500,
      message: "Could not re-enable intent, please try again later"
    };
  }

  dispatch(action);
};

export const clearReEnableIntentResponse = () => {
  return {
    type: CLEAR_RE_ENABLE_INTENT_RESPONSE
  };
};

export const triggerBotBuilding = (action = true) => {
  return {
    type: TRIGGER_BUILD_BOT,
    payload: action
  };
};

export const triggerCheckBotStatus = (action = true) => {
  return {
    type: TRIGGER_CHECK_BOT_STATUS,
    payload: action
  };
};

export const updateFallbackIntent = (intentId, plainTextResponse, richCardResponse, connectionName) => async (
  dispatch,
  getState
) => {
  const state = getState();

  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "UpdateFallbackIntent",
      IntentId: intentId,
      PlainTextResponse: plainTextResponse,
      RichHtmlResponse: richCardResponse,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: UPDATE_FALLBACK_INTENT,
    payload: {
      connectionName: connectionName
    }
  };

  try {
    const response = await API.post(config.AWS_API_NAME, "intents", data);

    action.payload.code = response.code;
    action.payload.message = response.message;
  } catch (err) {
    action.payload.code = 500;
    action.payload.message = err;
  }

  dispatch(action);
};

export const clearUpdateFallbackIntentResponse = () => {
  return {
    type: CLEAR_UPDATE_FALLBACK_INTENT_RESPONSE
  };
};
